import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Popconfirm, Table } from 'antd';

import util from '@util/index';

class TableCheck extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  columns = () => {
    const target = ['支出', '收入'];
    const { isArchived, accountInfo, noOp } = this.props;
    return [
      {
        title: '入账日',
        dataIndex: 'date',
        render: (text, record) => (
          <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>
        ),
      },
      {
        title: '摘要',
        dataIndex: 'remark',
      },
      {
        title: '收支类型',
        dataIndex: 'target',
        render: (text, record) => <span>{target[text]}</span>,
      },
      {
        title: '发生额',
        dataIndex: 'money',
        render: text => <apan>{text ? util.numberFormat(text) : ''}</apan>,
      },
      {
        title: '匹配额',
        dataIndex: 'confirm',
        render: text => <apan>{text ? util.numberFormat(Math.abs(text)) : ''}</apan>,
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) =>
          !noOp && !isArchived && accountInfo.isHatcherMng ? (
            <Popconfirm onConfirm={() => this.props.onCancel(record.uuid)} title="确认解除匹配吗">
              <a>解除匹配</a>
            </Popconfirm>
          ) : (
            <span>-</span>
          ),
      },
    ];
  };

  render() {
    const { dataSource } = this.props;
    return <Table columns={this.columns()} dataSource={dataSource} rowKey="uuid" />;
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(TableCheck);



// WEBPACK FOOTER //
// ./src/components/incubator/bill/TableCheck.js